import React from 'react';

type EgretProps = {
  className?: string;
  color?: string;
  width?: string;
  height?: string;
};

const defaultSVGProps = {
  width: '100%',
  color: '#fff',
};

function Egret({
  className,
  color,
  width,
  height,
}: EgretProps) {
  const isDimensionsUndefined = width === undefined && height === undefined;

  const svgProps = {
    width: isDimensionsUndefined ? defaultSVGProps.width : width,
    height,
    className,
  };

  const pathProps = {
    fill: color || defaultSVGProps.color,
  };

  return (
    <svg {...svgProps} version="1.1" viewBox="0 0 654 862" xmlns="http://www.w3.org/2000/svg">
      <path {...pathProps} d="m351 389c11.57-11.68 23.87-28.07 30.88-43 4.85-10.32 9.05-27.64 11.32-39 3.15-15.77 5.83-31.89 5.8-48-0.01-8.5-1.28-20.79-5.97-28-3.06-4.7-11.4-10.69-16.03-14.59-9.25-7.8-21.41-18.55-28.23-28.41-11.38-16.47-9.99-43.63-9.77-63 0.28-23.31 11.99-64.71 24.89-84 4.22-6.32 8.8-10.7 14.11-16 15.47-15.47 26.48-23.73 49-24 8.12-0.09 14.94-0.23 23 1.31 9.63 1.84 42.52 14.36 52 18.95l10 5.21 8 5.13 27 8.06 74 22.67c8.01 2.67 27.05 8.07 33 12.67l-33-2.09-50-4-38-3-13-0.91s-26 2.83-26 2.83l-35 3c-9.73 0.93-32.83 1.81-41 4.72-5.59 1.99-9.84 5.31-13.99 9.46-11.31 11.32-15.19 24.38-15.01 39.99 0.24 19.82 9.99 45.26 23.17 60 10.85 12.13 20.14 15.08 24.65 19.33 7.81 7.35 12.06 23.13 12.18 33.67l-0.91 13-3.81 39-13.2 86-6.68 35c-1.89 9.37-4.34 20.95-9.49 29-7.99 12.48-32.25 39.04-43.08 51-5.13 5.67-11.22 10.68-15.61 17-2.58 3.72-4.28 13.57-6.27 19-3.89 10.6-8.58 18.73-14.98 28-4.7 6.82-10.58 14.27-16.97 19.54-3.3 2.72-12.98 9.19-14.4 12.63-0.96 2.34-0.57 11.73-0.6 14.83l-0.91 10c-0.82 11.98-1.12 24.25-3.99 36-2.24 9.18-4.63 11.24-6 16l-2.52 15-4.44 13v16l0.86 15v53l1 17v47l1 15v7c-2.51-0.93-5.47-1.98-6.98-4.38-1.16-1.84-2.02-16.64-2.02-19.62v-51l-1-15v-43l-1-15v-16c-0.02-10.37-0.98-7.36-3.56-16l-2.64-12c-2.13-11.04-7.71-51.86-7.8-62l-14 1.91-11 0.65-28 15.22-17.98 9.63-2.19 13.59-3.63 23-4.94 17-5.17 59s-4.09 47-4.09 47c-2.63-0.97-7.2-2.66-8.26-5.39-1.2-2.29-0.01-6.98 0-9.61 0 0 1.84-21 1.84-21s0.51-9 0.51-9l2.08-25 2.81-35-1.98-17c-0.1-8.87-0.02-24.69 2-33-4.99 0.94-17.58 3.74-22 3.66-3.37-0.06-6.97-1.28-8.11-4.72-0.91-2.18-0.26-4.73 0-6.94-6.21 6.32-13.26 13.86-20.89 18.53l-13 6.01-9 6.76c-10.85 7.04-26.66 14.4-39 18.36-6.95 2.22-25.97 7.45-31.3 1.06-2.67-3.2-2.66-7.79-2.7-11.72-9.28 5.18-13.89 8.7-25 6 3.21-12.8 12.19-16.1 16.19-22.04l9.39-23.96c9.38-25.09 23.79-69.67 34.68-92 7.43-15.25 22.07-38.02 32.03-52 19.36-27.16 42.11-53.83 68.71-74.12 19.66-14.99 23.19-13.95 41-24.48l20-11.7c17.24-9.47 30.33-16.8 49-23.75 10.18-3.79 21.02-6.88 32-5.78 9.04 0.9 17.6 4.73 25 9.87 4.66 3.24 8.75 6.58 12.38 10.96 5.7 6.88 8.63 12.29 10.62 21z" />
    </svg>
  );
}

export default Egret;
